import { useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router';
import { requete } from '../../api/client';
import { messageErreur } from '../../api/erreurs';
import { useSession } from '../../session/FournisseurSession';
import { peut } from '../../session/permissions';
import { EnTetePage } from '../../commun/EnTetePage';
export function PageNotifications() {
  const { contexte } = useSession();
  const client = useQueryClient();
  const [decalage, setDecalage] = useState(0);
  const [erreur, setErreur] = useState('');
  const [enCours, setEnCours] = useState(false);
  const q = useQuery({
    queryKey: ['notifications-reseau', decalage],
    queryFn: () =>
      requete<{
        total: number;
        non_lues: number;
        elements: {
          id: string;
          titre: string;
          lien: string;
          cree_le: string;
          lu_le: string | null;
        }[];
      }>('/notifications-reseau', { parametres: { decalage } }),
    enabled: peut(contexte, 'intervention', 'voir'),
    refetchInterval: 60000,
    staleTime: 0,
  });
  if (!peut(contexte, 'intervention', 'voir')) return <p role="alert">Accès non autorisé.</p>;
  return (
    <section>
      <EnTetePage titre="Mes notifications" />
      <p>Notifications internes à votre organisation active.</p>
      {q.isPending && <p>Chargement…</p>}
      {(erreur || q.error) && <p role="alert">{erreur || messageErreur(q.error)}</p>}
      {q.data && (
        <>
          <p>
            {q.data.non_lues} non lue(s) sur {q.data.total} notification(s).
          </p>
          <ul>
            {q.data.elements.map((n) => (
              <li key={n.id} style={{ marginBlock: 16 }}>
                <strong>{n.titre}</strong> — {new Date(n.cree_le).toLocaleString('fr-FR')} —{' '}
                {n.lu_le ? 'Lue' : 'Non lue'} <Link to={n.lien}>Consulter les interventions</Link>
                {!n.lu_le && (
                  <button
                    disabled={enCours}
                    onClick={async () => {
                      setErreur('');
                      setEnCours(true);
                      try {
                        await requete(`/notifications-reseau/${n.id}/lire`, { methode: 'POST' });
                        await client.invalidateQueries({ queryKey: ['notifications-reseau'] });
                      } catch (err) {
                        setErreur(messageErreur(err));
                      } finally {
                        setEnCours(false);
                      }
                    }}
                  >
                    Marquer comme lue
                  </button>
                )}
              </li>
            ))}
          </ul>
          <button
            disabled={decalage === 0}
            onClick={() => setDecalage(Math.max(0, decalage - 100))}
          >
            Précédentes
          </button>
          <button
            disabled={decalage + 100 >= q.data.total}
            onClick={() => setDecalage(decalage + 100)}
          >
            Suivantes
          </button>
        </>
      )}
    </section>
  );
}
